export const MEAL_TYPE_BREAKFAST = { label: "Breakfast", value:"breakfast" };  
export const MEAL_TYPE_LUNCH = { label: "Lunch", value:"lunch" };  
export const MEAL_TYPE_DINNER = { label: "Dinner", value:"dinner" };  
export const MEAL_TYPE_SNACKS = { label: "Snacks", value:"snacks" };  
  
export const EMPTY_ID = "00000000-0000-0000-0000-000000000000";  
  
export const MEAL_OPTIONS = {
  breakfast: MEAL_TYPE_BREAKFAST,
  lunch: MEAL_TYPE_LUNCH,
  dinner: MEAL_TYPE_DINNER,
  snacks: MEAL_TYPE_SNACKS
};  
  
export const ID_LENGTH = 36;  
export const INITIAL_ITEMS_PER_PAGE = 10;  
export const INITIAL_SNACKS = 0;  
export const INITIAL_QUANTITY = 1;  